import  { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ModalDetailPostProps {
  isOpen: boolean;
  onClose: () => void;
  post?: any | null;
}

export default function ModalViewPost({
  isOpen,
  onClose,
  post,
}: ModalDetailPostProps) {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen && post) {
      setIsLoading(true);
      const t = setTimeout(() => setIsLoading(false), 500);
      return () => clearTimeout(t);
    }
  }, [isOpen, post]);

  if (!post) return null;

  const getThumbUrl = (thumb?: string) => {
    if (!thumb) return "";
    if (thumb.startsWith("http")) return thumb;
    return `https://api.ophim69.com/api/v1/${thumb}`;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Chi tiết post</DialogTitle>
        </DialogHeader>

        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <div className="flex flex-col items-center gap-3">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
              <p className="text-sm text-gray-600">Đang tải thông tin...</p>
            </div>
          </div>
        ) : (
          <div className="p-1 flex flex-col gap-6 w-full">
            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tiêu đề
              </label>
              <div className="p-3 bg-gray-50 border rounded-lg">
                <p className="text-gray-900 font-medium">
                  {post.name || "Chưa có tiêu đề"}
                </p>
              </div>
            </div>

            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Mô tả
              </label>
              <div className="p-4 bg-gray-50 border rounded-lg min-h-[200px] max-h-[400px] overflow-y-auto">
                {post.description ? (
                  <div
                    className="prose prose-sm max-w-none text-gray-900"
                    dangerouslySetInnerHTML={{ __html: post.description }}
                  />
                ) : (
                  <p className="text-gray-500 italic">Chưa có mô tả</p>
                )}
              </div>
            </div>

            <div className="w-full">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Thumbnail
              </label>
              <div className="flex justify-center">
                {post.thumbnail ? (
                  <div className="relative w-64 h-80 border rounded-lg overflow-hidden shadow-md">
                    <img
                      src={getThumbUrl(post.thumbnail)}
                      alt="Thumbnail post"
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        (e.target as HTMLImageElement).src =
                          "https://via.placeholder.com/300x400?text=Không+có+ảnh";
                      }}
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black/50 text-white text-xs p-2 text-center">
                      Thumbnail
                    </div>
                  </div>
                ) : (
                  <div className="w-64 h-80 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50">
                    <div className="text-center text-gray-500 text-sm">
                      Không có thumbnail
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
